import React from 'react';
import Advertisements from "../../images/Advertisements.png";
import image1 from "../../images/AdvertSideImage (1).png";
import image2 from "../../images/AdvertSideImage (2).png";
import image3 from "../../images/AdvertSideImage (3).png";
import image4 from "../../images/Rectangle 333.png";
// Data configuration for the sidebar cards to keep code dry
const sidebarData = [
  {
    id: 1,
    tag: "Solar energy",
    tagBg: "bg-[#664101]",
    date: "Mar 03, 2026",
    title: "Ensuring safety and optimised production of lithium batteries",
    description: "Lithium batteries are crucial for decarbonisation. We must boost production and reduce costs.",
    image: image1
  },
  {
    id: 2,
    tag: "Clean Energy",
    tagBg: "bg-[#00AED9]",
    date: "Feb 14, 2026",
    title: "Next-level blue hydrogen production with advanced measurement",
    description: "Discover measurement solutions to enhance plant safety, boost efficiency, and lower energy use.",
    image: image2
  },
  {
    id: 3,
    tag: "Sustainability",
    tagBg: "bg-[#40B869]",
    date: "Jan 21, 2026",
    title: "Is your workplace updated on sustainable hygiene?",
    description: "Discover the benefits and approach to sustainable hygiene solutions in the workplace.",
    image: image3
  }
];

export default function AdvertisementLayout() {
  return (
    <div className="flex flex-col mt-20 items-start gap-[40px] w-full max-w-[1200px] h-auto min-h-[1078px] mx-auto p-4 md:p-0">
      {/* Header section */}
      <div className="flex flex-col items-start gap-[32px] w-full h-[43px]">
        <h2 className="w-full text-[36px] font-medium leading-[43px] text-[#3B3B3B] ">
          Advertisements
        </h2>
      </div>

      {/* Main Content Area */}
      <div className="flex flex-row flex-wrap items-start content-start gap-[24px] w-full min-h-[995px]">
        
        {/* Left Side: Hero Banner Card */}
        <HeroCard />

        {/* Right Side: Small Vertical Cards Column */}
        <div className="flex flex-col justify-center items-start  w-full lg:w-[410px] h-auto lg:h-[681px]">
          {sidebarData.map((card) => (
            <SidebarCard key={card.id} {...card} />
          ))}
        </div>

        {/* Bottom Section: Full Width Horizontal Banner */}
        <BottomCard />
      </div>
    </div>
  );
}

/* ==========================================
   SUB-COMPONENTS FOR CLEAN ARCHITECTURE
   ========================================== */

function HeroCard() {
  return (
    <div className="relative w-full lg:w-[766px] h-[682px]   rounded-[16px] overflow-hidden group">
      {/* Background Image Layer */}
      <img src={Advertisements} alt="Hero Advertisement" 
        className="absolute mt-10 object-cover bg-center rounded-t-xl "
      />
      
      {/* Backdrop Tint Blur Overlay */}
      <div className="absolute inset-0 bg-black/28 " />

      {/* Top Header Floating Tags */}
      <div className="absolute left-[5px] top-[36px] flex flex-row items-center gap-[8px] h-[25px] p-10">
        <div className="flex flex-row justify-center items-center px-[8px] py-[2px] h-[25px] bg-[#7BC216] rounded-[4px]">
          <span className="text-[18px] font-normal text-white ">Clean Energy</span>
        </div>
        <div className="w-[10px] h-[10px] bg-[#D9D9D9] rounded-full" />
        <span className="text-[18px] font-normal text-white ">Mar. 13, 2026</span>
      </div>

      {/* Inner Main Content Block */}
      <div className="absolute left-[36px] top-[334px] flex flex-col items-start gap-[24px] w-[calc(100%-72px)] max-w-[657px]">
        <div className="flex flex-col items-start gap-[12px] w-full">
          <div className="flex flex-col items-start gap-[16px] w-full">
            <h3 className="w-full text-[36px] font-semibold text-white leading-[120%] font-['Inter']">
              Revolutionizing Grid Stability with Tier-1 Solar Storage
            </h3>
            <p className="w-full text-[18px] font-normal text-[#D0D5DD] leading-[120%] tracking-[0.01em] font-['Inter']">
              As our featured Sustainability Partner, EcoWatt provides CloseCarbon-verified energy infrastructure that reduces operational carbon footprints by up to 40% for heavy.
            </p>
          </div>
        </div>

        {/* Action Elements Row */}
        <div className="flex flex-row items-center justify-between w-full flex-wrap gap-4">
          <div className="flex flex-row items-center gap-[12px]">
            {/* Meta Pill 1 */}
            <div className="flex justify-center items-center px-[16px] py-[8px] h-[33px] bg-black/5 border border-[#898989] backdrop-blur-[12.5px] rounded-[16px]">
              <span className="text-[14px] font-normal text-[#B1B1B1] ">99.9% Up time</span>
            </div>
            {/* Meta Pill 2 */}
            <div className="flex justify-center items-center px-[16px] py-[8px] h-[33px] bg-black/25 border border-[#898989] backdrop-blur-[20px] rounded-[16px]">
              <span className="text-[14px] font-normal text-[#B1B1B1] ">Nigeria-Wide Support</span>
            </div>
          </div>

          {/* Core Button Container */}
      
        </div>
            <button className="flex flex-row justify-center items-center px-[36px] py-[12px] bg-white border-2 border-[#006633] rounded-[8px] active:scale-95 transition-transform">
            <span className="text-[16px] font-medium text-[#006633] leading-[145%] font-['Inter']">Learn more</span>
          </button>
      </div>
    </div>
  );
}

function SidebarCard({ tag, tagBg, date, title, description, image }) {
  return (
    <div className="box-border mt-10 flex flex-row items-center p-0 pl-[12px] pr-[12px] gap-[3px] w-full lg:w-[410px] h-[211px] bg-white border-[0.32px] border-[#E4E7EC] shadow-[0px_7px_29px_rgba(100,100,111,0.2)] rounded-[12px]">
      {/* Left-Side Thumbnail */}
      <img 
        className="box-border w-[199px] h-[181px] bg-cover bg-center border-[0.32px] border-[#FAFAFA] rounded-[6px] p-3 "
        src={image}
        alt="Advertisement Thumbnail"
      />

      {/* Right-Side Meta/Details Stack */}
      <div className="flex flex-col items-start gap-[12px] w-[175px] h-[147px]">
        <div className="flex flex-col items-start gap-[12px] w-full">
          {/* Top Tag Bar */}
          <div className="flex flex-row items-center gap-[4px] w-full">
            <div className={`flex justify-center items-center px-[4px] py-[1px] h-[12px] ${tagBg} rounded-[1.91px]`}>
              <span className="text-[8.6px] font-normal text-white  truncate whitespace-nowrap">{tag}</span>
            </div>
            <div className="w-[4.8px] h-[4.8px] bg-[#D9D9D9] rounded-full shrink-0" />
            <span className="text-[10px] font-normal text-[#B1B1B1]  whitespace-nowrap">{date}</span>
          </div>

          {/* Card Headings */}
          <div className="flex flex-col items-start gap-[4px] w-full">
            <h4 className="w-full text-[14px] font-bold text-[#3B3B3B] leading-[17px]  line-clamp-3">
              {title}
            </h4>
            <p className="w-[148px] text-[10px] font-normal text-[#898989] leading-[12px]  line-clamp-3">
              {description}
            </p>
          </div>
        </div>

        {/* Read More Inline Link */}
        <a href="#read-more" className="flex flex-row justify-center items-center gap-[8px] h-[20px] group">
          <span className="text-[14px] font-medium text-[#006633] leading-[145%] font-['Inter'] group-hover:underline">Read More</span>
          <svg className="w-[9px] h-[18px] text-[#006633] fill-current transform scale-x-[-1]" viewBox="0 0 24 24">
            <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
          </svg>
        </a>
      </div>
    </div>
  );
}

function BottomCard() {
  return (
    <div className=" box-border  flex flex-col md:flex-row items-center p-0 pr-0 md:pr-[24px] gap-[36px] w-full max-w-[1200px] min-h-[289px] bg-white border border-[#E4E7EC] shadow-[0px_7px_29px_rgba(100,100,111,0.2)] rounded-[14px] overflow-hidden mt-4">
      {/* Large Featured Side Graphic */}
      <img 
        className=" w-full md:w-[579px] rounded-sm h-[289px] bg-cover bg-center border border-[#FAFAFA]"
        src={image4}
        alt="Advertisement Thumbnail"
      />

      {/* Broad Content Canvas */}
      <div className="flex flex-col justify-center items-start gap-[32px] w-full md:w-[561px] p-6 md:p-0">
        <div className="flex flex-col items-start gap-[16px] w-full">
          {/* Header Tag and Date Info */}
          <div className="flex flex-row items-center gap-[8px] h-[25px]">
            <div className="flex justify-center items-center px-[8px] py-[2px] h-[25px] bg-[#004617] rounded-[4px]">
              <span className="text-[18px] font-normal text-white ">Electric cars</span>
            </div>
            <div className="w-[10px] h-[10px] bg-[#D9D9D9] rounded-full" />
            <span className="text-[18px] font-normal text-[#898989] ">Mar. 10, 2026</span>
          </div>

          {/* Typography Copy details */}
          <div className="flex flex-col items-start gap-[16px] w-full">
            <h3 className="w-full text-[28px] font-medium text-[#3B3B3B] leading-[33px] ">
              New electric vehicle tech takes network management to the next Level
            </h3>
            <p className="w-full max-w-[470px] text-[16px] font-normal text-[#898989] leading-[19px] ">
              Learn about advanced measurement solutions that can maximise your plant safety and reliability, increase operational efficiency and reduce energy consumption.
            </p>
          </div>
        </div>

        {/* Action Button */}
        <button className="flex justify-center items-center px-[24px] py-[8px] bg-white border-2 border-[#006633] rounded-[8px] active:scale-95 transition-transform">
          <span className="text-[16px] font-medium text-[#006633] leading-[145%] font-['Inter']">Learn more</span>
        </button>
      </div>
    </div>
  );
}